import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';
import { AtlasPatologiaPage } from './atlas-patologia';
import { AtlasPatologiaPageProvider } from './atlas-patologia.provider';
import { AtlasPatologiaProvider } from '../../providers/atlas-patologia/atlas-patologia';

@NgModule({
  declarations: [
    AtlasPatologiaPage,
  ],
  imports: [
    ComponentsModule,
    PipesModule,
    IonicPageModule.forChild(AtlasPatologiaPage),
  ],
  providers:[
    AtlasPatologiaPageProvider,
    AtlasPatologiaProvider
  ]
})
export class AtlasPatologiaPageModule {

}



// WEBPACK FOOTER //
// ./src/pages/atlas-patologia/atlas-patologia.module.ts